import { render, staticRenderFns } from "./MyIntroduce5.vue?vue&type=template&id=22b21bca&scoped=true"
import script from "./MyIntroduce5.vue?vue&type=script&lang=js"
export * from "./MyIntroduce5.vue?vue&type=script&lang=js"
import style0 from "./MyIntroduce5.vue?vue&type=style&index=0&id=22b21bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b21bca",
  null
  
)

export default component.exports